module.exports = __webpack_public_path__ + "assets/email.80c27374.svg";